'use client';
import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

export type CountDownProps = {
  startTime: number; // 开始时间（ISO格式字符串）
  endTime: number; // 结束时间（ISO格式字符串）
  onEnd?: () => void; // 倒计时结束时的回调
  size?: 'sm' | 'md' | 'lg';
  type?: 'black' | 'red';
  context?: string;
  isActive?: boolean;
  onlyText?: boolean;
  classnames?: string;
};

export const CountDown = (props: CountDownProps) => {
  const {
    startTime,
    endTime,
    onEnd,
    size = 'sm',
    type = 'black',
    context,
    isActive = false,
    onlyText = false,
    classnames = '',
  } = props;
  const [timeLeft, setTimeLeft] = useState(() => {
    const now = startTime; // 当前时间（UNIX秒）
    const duration = endTime - now; // 计算剩余时间（秒）
    return Math.max(0, duration); // 确保不为负
  });

  // console.log('dayjs', dayjs(startTime * 1000).format('YYYY-MM-DD HH:mm:ss'));
  // console.log('dayjs', dayjs(endTime * 1000).format('YYYY-MM-DD HH:mm:ss'));

  const theme = {
    red: 'text-white bg-btn-red',
    black: 'text-white bg-primary',
  };

  const sizeClasses = {
    sm: 'w-6 h-6 rounded text-[14px] leading-6',
    md: 'w-12 h-12 p-1.5 text-[28px] rounded-lg leading-normals',
    lg: 'text-lg p-3 w-full rounded-3xl',
  };

  const symbolClasses = {
    sm: 'w-2 h-6 text-[14px] pt-0.5',
    md: 'w-3 h-12 text-[28px] pt-1',
    lg: '',
  };

  const parentSize = {
    sm: 'h-4',
    md: 'w-12 h-12',
    lg: 'w-12 h-12',
  };

  const color = {
    red: 'text-btn-red',
    black: 'text-primary',
  };

  const contentClasses = {
    sm: 'text-[12px] h-6 items-center justify-center text-second leading-6 pl-1.5',
    md: 'text-[14px] h-12 pl-2.5 items-end justify-end text-second',
    lg: 'text-lg',
  };

  const formatTime = (time: number) => {
    const hours = Math.floor(time / 3600)
      .toString()
      .padStart(2, '0');
    const minutes = Math.floor((time % 3600) / 60)
      .toString()
      .padStart(2, '0');
    const seconds = (time % 60).toString().padStart(2, '0');
    return { hours, minutes, seconds };
  };

  useEffect(() => {
    if (timeLeft === 0) {
      if (onEnd) onEnd();
      return;
    }

    if (!isActive) return;

    const timerId = setInterval(() => {
      setTimeLeft((prevTime) => {
        const newTime = prevTime - 1;
        if (newTime === 0) {
          clearInterval(timerId);
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(timerId);
  }, [timeLeft, onEnd, isActive]);

  const { hours, minutes, seconds } = formatTime(timeLeft);
  if (onlyText) {
    return (
      <div className={classnames}>
        {hours}:{minutes}:{seconds}
      </div>
    );
  } else {
    return (
      <div className={`flex `}>
        <div
          className={`flex justify-center align-center text-center ${theme[type]} ${sizeClasses[size]}`}
        >
          {hours}
        </div>
        <div className={`flex justify-center align-center ${color[type]} ${symbolClasses[size]}`}>
          :
        </div>
        <div className={`flex justify-center align-center ${theme[type]} ${sizeClasses[size]}`}>
          {minutes}
        </div>
        <div className={`flex justify-center align-center ${color[type]} ${symbolClasses[size]}`}>
          :
        </div>
        <div className={`flex justify-center  align-center ${theme[type]} ${sizeClasses[size]}`}>
          <div>{seconds}</div>
        </div>
        <div className={`flex  ${contentClasses[size]}`}>{context}</div>
      </div>
    );
  }
};
